
import { mapState, mapMutations } from "vuex";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/privacy-notice",
      "fr-ca": "/avis-confidentialite",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  head() {
    return {
      title: this.$t("global.legalNav.privacyNoticeMetaTitle"),
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.$t("global.legalNav.privacyNoticeMetaDesc"),
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.$t("global.legalNav.privacyNoticeMetaDesc"),
        },
      ],
      script: [
        {
          src: "https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js",
          sandbox: "allow-same-origin allow-scripts allow-popups allow-forms",
          type: "text/javascript",
          charset: "UTF-8",
          id: "otprivacy-notice-script",
          innerHTML: "settings=\"eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9\""
        },
      ],
      __dangerouslyDisableSanitizers: ['script']
    };
  },
  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);

    const oneTrustInit = setInterval(onTrustFunction, 500);

    function onTrustFunction() {
      if(OneTrust) {
        OneTrust.NoticeApi.Initialized.then(function() {
          OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/be50c92d-7644-4fdd-98ba-0d1bb4bde7cb.json"]);
        });
        clearInterval(oneTrustInit);
      }
    }
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          90 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
